import cx from 'classnames'
import { Drawer as AntdDrawer, DrawerProps } from 'antd'
import styles from './index.module.scss'

export function Drawer({ className, ...props }: DrawerProps) {
  return <AntdDrawer {...props} className={cx(styles.drawer, className)} />
}
